  import FullTable from 'js/components/full-table/index.js'
  import template from './_table.pug'

  export default Vue.extend({
    template: template(),
    components: {
      FullTable
    },
    props: {
      rules: {
        type: Array,
        required: true
      },
      meta: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        showFilters: false,
        showDeleteModal: false,
        ruleToDelete: null,
        isDeleting: false,
        filters: {
          accountName: '',
          name: '',
          tableName: ''
        },
        lastQueryOptions: null
      }
    },
    methods: {
      t(key) {
        return this.$t(`aiInfinityRules.index.${key}`);
      },

      formatDate(value){
        if (!value) return '_'

        const match = String(value).match(/^(\d{4,})-(\d{2})-(\d{2})/)
        if (!match) return value
        const [, year, month, day] = match

        if (parseInt(year, 10) >= 3000) return `${day}/${month}/${year}`
        return `${day}/${month}/${year}` 
      },

      emitLoadData(queryOptions) {
        this.$emit('load-data', queryOptions || this.lastQueryOptions)
        if (queryOptions) {
          this.lastQueryOptions = queryOptions
        }
      },

      openDeleteModal(rule) {
        this.ruleToDelete = rule
        this.showDeleteModal = true
      },
      closeDeleteModal() {
        this.showDeleteModal = false,
        this.ruleToDelete = null
      },
      confirmDelete() {
        if (!this.ruleToDelete) return

        this.isDeleting = true

        API.aiInfinityRules.destroy(this.ruleToDelete.id)
          .then(() => {
            this.$notifications.success(this.t('succesfullyDeleted'))
            this.closeDeleteModal()
            this.emitLoadData()
          })
          .catch(error => {
            console.error(error)
            this.$notifications.error(this.t('errorDeleted'))
          })
          .finally(() => {
            this.isDeleting = false
          })
      }
    }
  })